import { createAction, props } from '@ngrx/store';
import { ResearcherRequest } from '../../../models/researcher-request';

export const getRequests = createAction('[Researcher Requests] Get Researcher Requests');

export const getRequestsSuccess = createAction(
  '[Researcher Requests] Get Researcher Requests Success',
  props<{ requests: ResearcherRequest[] }>()
);

export const getRequestsError = createAction('[Researcher Requests] Get Researcher Requests Error');

export const acceptRequest = createAction(
  '[Researcher Requests] Accept Researcher Request',
  props<{ request: ResearcherRequest }>()
);

export const acceptRequestSuccess = createAction(
  '[Researcher Requests] Accept Researcher Request Success',
  props<{ acceptedRequest: ResearcherRequest }>()
);

export const acceptRequestError = createAction(
  '[Researcher Requests] Accept Researcher Request Error',
  props<{ error: JSON }>()
);

export const rejectRequest = createAction(
  '[Researcher Requests] Reject Researcher Request',
  props<{ request: ResearcherRequest }>()
);

export const rejectRequestSuccess = createAction(
  '[Researcher Requests] Reject Researcher Request Success',
  props<{ rejectedRequest: ResearcherRequest }>()
);

export const rejectRequestError = createAction(
  '[Researcher Requests] Reject Researcher Request Error',
  props<{ error: JSON }>()
);
